<template>
  <div class="-ml-2 text-grey-darker flex items-center justify-between text-base text-left whitespace-pre h-6 mt-8">
    <span class="mr-6">Showing <b>1</b> to <b>{{((currentPage - 1) * perPage) + perPage}}</b> of <b>{{totalItems}} rows</b></span>
    <div class="flex">
      <div class="flex mr-8">
        <!-- <span class="h-6 w-6 rounded">{{'<'}}</span> -->
        <span @click="currentPage > 1 && changePage(currentPage-1)" class="h-8 w-8 flex items-center justify-center border-grey border hover:bg-grey-lightest rounded cursor-pointer"><img class="h-4 w-4" src="@/assets/icon-chevron-left.svg" alt="location icon"/></span>
        <span @click="changePage(n)" v-for="n in Math.ceil(totalItems/perPage)" :key="`pagin-${n}`" :class="`h-8 w-8 flex items-center hover:bg-grey-lightest cursor-pointer justify-center border-grey border rounded ${currentPage === n && 'bg-green text-white'}`">{{n}}</span>
        <span @click="currentPage < Math.ceil(totalItems/perPage) - 1 && changePage(currentPage+1)" class="h-8 w-8 flex items-center hover:bg-grey-lightest justify-center cursor-pointer border-grey border rounded"><img class="h-4 w-4" src="@/assets/icon-chevron-right.svg" alt="location icon"/></span>
      </div>
      <div class="relative flex items-center justify-center h-8 border rounded">
        <span @click="toggleMenu()" class="cursor-pointer text-grey ml-1">{{perPage}} / page</span>
        <span class="ml-2 mb-1">
          <svg class="cursor-pointer" @click="toggleMenu(true)" width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
              <path d="M5.5,6 C5.23993351,6 4.97986701,5.90832554 4.78176949,5.72591207 L0,1.32273152 L1.43646103,0 L5.5,3.74181478 L9.56353897,0 L11,1.32273152 L6.21823051,5.72591207 C6.02013299,5.90832554 5.76006649,6 5.5,6 Z" id="Shape" fill="#2B4864" fill-rule="nonzero"></path>
            </g>
          </svg>
          <div v-show="menuOpened" class="z-10 rounded bg-white shadow-md mt-8 absolute mt-12 pin-t pin-r">
            <ul class="list-reset">
              <li>
                <a @click="changePerPage(10)" class="cursor-pointer px-4 py-2 block text-navy hover:bg-navy hover:text-white no-underline">10 / page</a>
                <a @click="changePerPage(20)" class="cursor-pointer px-4 py-2 block text-navy hover:bg-navy hover:text-white no-underline">20 / page</a>
                <a @click="changePerPage(30)" class="cursor-pointer px-4 py-2 block text-navy hover:bg-navy hover:text-white no-underline">30 / page</a>
              </li>
            </ul>
          </div>
        </span>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    totalPages: {
      type: Number,
      default () {
        return 10
      },
    },
    totalItems: {
      type: Number,
      default () {
        return 130
      },
    },
    perPage: {
      type: Number,
      default () {
        return 10
      },
    },
    currentPage: {
      type: Number,
      default () {
        return 1
      },
    },
    pageChanged: {
      type: Function,
      default () {
        return () => {}
      },
    },
  },
  data() {
    return {
      menuOpened: false,
    }
  },
  methods: {
    changePerPage(number) {
      this.$emit('changePerPage', number);
      this.toggleMenu();
    },
    toggleMenu() {
      this.menuOpened = !this.menuOpened;
    },
    changePage(page) {
      this.$emit('changePage', page);
    },
  },
}
</script>
<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/TableComponents/Pagination.vue